<template>
  <div class="row statisticsdata"
                v-bind:class="{
                  'statistics-data-mid': client_name == 'MID',
                  'statistics-data-dy': client_name == 'DY',
                }">
    <div class="col-6">
      <h3 class="chartDataH3">{{h3Left}}</h3>
      <div class="row">
        <div class="col-6">
          <p class="chartDataLabel">{{thisLabelLeft}}</p>
          <h5
            class="chartDataValue chartDataValueThis "
            v-bind:class="{'chartDataValuePlus': thisValueLeft>0,'chartDataValueMinus': thisValueLeft<0 }"
            id="thisWeekLabel"
          >
            {{thisValueLeft}}%
          </h5>
        </div>
        <div class="col-6">
          <p class="chartDataLabel">{{lastLabelLeft}}</p>
          <h5 class="chartDataValue chartDataValueLast" id="lastWeekLabel">
            {{lastValueLeft}}%
          </h5>
        </div>
      </div>
    </div>
    <div class="col-6">
      <h3 class="chartDataH3">{{h3Right}}</h3>
      <div class="row">
        <div class="col-6" v-if="thisValueRight">
          <p class="chartDataLabel">{{thisLabelRight}}</p>
          <h5
            class="chartDataValue chartDataValueThis"
            v-bind:class="{'chartDataValuePlus': thisValueRight>0,'chartDataValueMinus': thisValueRight<0 }"
            id="thisMonthLabel"
          >
            {{thisValueRight}}%
          </h5>
        </div>
        <div class="col-6" v-if="lastValueRight">
          <p class="chartDataLabel">{{lastLabelRight}}</p>
          <h5 class="chartDataValue chartDataValueLast" id="lastMonthLabel">
            {{lastValueRight}}%
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardStatisticsData",
  props: ["h3Left", "thisLabelLeft","thisValueLeft","lastLabelLeft","lastValueLeft",
          "h3Right", "thisLabelRight","thisValueRight","lastLabelRight","lastValueRight",
          "client_name"],
  data() {
    return {
    };
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dashboard/StatisticsData.vue